export default __webpack_public_path__ + "static/media/trenza-verde.c560f57f.png";